import { render, staticRenderFns } from "./MySalons.vue?vue&type=template&id=05012d81&scoped=true"
import script from "./MySalons.vue?vue&type=script&lang=js"
export * from "./MySalons.vue?vue&type=script&lang=js"
import style0 from "./MySalons.vue?vue&type=style&index=0&id=05012d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05012d81",
  null
  
)

export default component.exports